import { ReactElement } from "react";

import { Button } from "@chakra-ui/react";
import Empty, { EmptyProps, EmptyVariants } from "components/Empty";

const EmptyWithClearButton = ({
  onClick,
  message,
  buttonText,
  hasFilters,
  hasSearch,
  buttonVisible,
  ...rest
}: {
  buttonText: string;
  buttonVisible: boolean;
  onClick(): void;
  hasFilters?: boolean;
  hasSearch?: boolean;
} & EmptyProps): ReactElement => {
  let variant: EmptyVariants;
  if (hasFilters) {
    variant = "filter";
  } else if (hasSearch) {
    variant = "search";
  }

  return (
    <Empty variant={variant} message={message} maxWidth="480px" p={4} {...rest}>
      {buttonVisible && (
        <Button colorScheme="grey" onClick={onClick} w="100%">
          {buttonText}
        </Button>
      )}
    </Empty>
  );
};

export default EmptyWithClearButton;
